<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">运输资源详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="运输资源名称" prop="name" style="display:inline-block;">
          <el-input v-model="ruleForm.name" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="运输资源类型" prop="resourceType" style="display:inline-block;">
          <el-select
            v-model="ruleForm.resourceType"
            placeholder="请选择运输资源类型"
            v-bind:disabled="IsEdit"
            style="width:50rem;"
          >
            <el-option
              v-for="item in options"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存放地址" prop="address" style="display:inline-block;">
          <el-input v-model="ruleForm.address" style="width:118rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="longitude" style="display:inline-block;">
          <el-input v-model="ruleForm.longitude" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="latitude" style="display:inline-block;">
          <el-input v-model="ruleForm.latitude" style="width:45rem;" v-bind:disabled="IsEdit"></el-input>
          <ZjLngLatSelect :point_lat="ruleForm.latitude" :point_lng="ruleForm.longitude" :disabled="IsEdit"
            @onGotLngLat="onGotLngLat" style="margin-left:0.5rem"></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts" style="display:inline-block;">
          <el-input v-model="ruleForm.contacts" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="联系人移动电话" prop="contactNo" style="display:inline-block;">
          <el-input v-model="ruleForm.contactNo" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="数量" prop="quantity" style="display:inline-block;">
          <el-input v-model="ruleForm.quantity" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="display:inline-block;">
          <el-input type="textarea" style="width:118rem;" v-model="ruleForm.remark" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="text-align:center;width:134rem;padding:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm()" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
  
</template>
<script>
import ZJApp from '../../../../../app';
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { save, update, detail } from "@/api/src/emergency_tranresources";
export default {
  name: "ZjTranresourcesinfo",
  controller: "EmergencyResource",
  action: "Tranresourcesinfo",
  props: {
    query: {
      type: String,
      id: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      ruleForm:{
              name: "",
              resourceType: "",
              address: "",
              longitude: "",
              latitude: "",
              contacts: "",
              contactNo: "",
              quantity: "0",
              remark: ""
            },
      options: [],
      rules: {
        address: [
          { required: true, message: "请输入存放地址", trigger: "blur" },
        ],
        longitude: [
          { required: true, message: "请输入经度", trigger: "blur" },
        ],
        latitude: [
          { required: true, message: "请输入纬度", trigger: "blur" },
        ],

        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          name: "",
          resourceType: "",
          address: "",
          longitude: "",
          latitude: "",
          contacts: "",
          contactNo: "",
          quantity: "0",
          remark: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        getDictionary('transportation_resouce_type'),
      ])
      .then(r => {
        //所属应急组织类型
        this.options = r[0].data.records;

        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });
    },
    search() {
      let { id } = this.query;
      if (id != null && id != "") {
        this.loading = true;
        this.loadingText = '加载中...';
        detail( id )
          .then(r => {
            r = r.data;
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.latitude = obj.lat;
      this.ruleForm.longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm() {
      //this.ruleForm = formName;
      this.ruleForm = {
          name: "",
          resourceType: "",
          address: "",
          longitude: "",
          latitude: "",
          contacts: "",
          contactNo: "",
          quantity: "0",
          remark: ""
        };
      //this.$refs[formName].resetFields();
      this.query.id = null;
    },
    save() {
      this.ruleForm.quantity = parseFloat(this.ruleForm.quantity);
      this.ruleForm.longitude = parseFloat(this.ruleForm.longitude);
      this.ruleForm.latitude = parseFloat(this.ruleForm.latitude);
      if (this.query.id == null||this.query.id == "") {
        this.loading = true;
        this.loadingText = '保存中...';
        save(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        update(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>